import { useEffect } from "react";

export default function TooltipManager() {
  useEffect(() => {
    let currentEl = null;

    const showTooltip = (el) => {
      const rect = el.getBoundingClientRect();
      const tooltipText = el.getAttribute("data-tooltip");
      if (!tooltipText) return;

      const tooltip = document.createElement("div");
      tooltip.className = "tooltip-box";
      tooltip.textContent = tooltipText;

      const arrow = document.createElement("div");
      arrow.className = "tooltip-arrow";

      document.body.appendChild(tooltip);
      document.body.appendChild(arrow);

      requestAnimationFrame(() => {
        tooltip.style.position = "fixed";
        tooltip.style.left = `${rect.left + rect.width / 2}px`;
        tooltip.style.top = `${rect.bottom + 10}px`;
        tooltip.style.transform = "translateX(-50%)";
        tooltip.style.opacity = "1";
        tooltip.style.background = "#333";
        tooltip.style.color = "#fff";
        tooltip.style.padding = "6px 10px";
        tooltip.style.borderRadius = "4px";
        tooltip.style.fontSize = "12px";
        tooltip.style.whiteSpace = "nowrap";
        tooltip.style.zIndex = "9999";
        tooltip.style.pointerEvents = "none";
        tooltip.style.transition = "opacity 0.2s ease";

        arrow.style.position = "fixed";
        arrow.style.left = `${rect.left + rect.width / 2}px`;
        arrow.style.top = `${rect.bottom + 4}px`;
        arrow.style.transform = "translateX(-50%)";
        arrow.style.opacity = "1";
        arrow.style.zIndex = "9999";
        arrow.style.pointerEvents = "none";
        arrow.style.transition = "opacity 0.2s ease";
        arrow.style.width = "0";
        arrow.style.height = "0";
        arrow.style.borderLeft = "6px solid transparent";
        arrow.style.borderRight = "6px solid transparent";
        arrow.style.borderTop = "6px solid #333";
      });

      el._tooltip = tooltip;
      el._arrow = arrow;
    };

    const hideTooltip = (el) => {
      if (el?._tooltip) {
        el._tooltip.remove();
        el._arrow.remove();
        el._tooltip = null;
        el._arrow = null;
      }
    };

    const handleMouseOver = (e) => {
      const target = e.target;
      if (!(target instanceof Element)) return;

      const el = target.closest(".tooltip-wrapper");
      if (el && el !== currentEl) {
        currentEl = el;
        showTooltip(el);
      }
    };

    const handleMouseOut = (e) => {
      const related = e.relatedTarget;
      if (!(related instanceof Element)) return;

      if (currentEl && !currentEl.contains(related)) {
        hideTooltip(currentEl);
        currentEl = null;
      }
    };

    document.addEventListener("mouseover", handleMouseOver, true);
    document.addEventListener("mouseout", handleMouseOut, true);

    return () => {
      document.removeEventListener("mouseover", handleMouseOver, true);
      document.removeEventListener("mouseout", handleMouseOut, true);
    };
  }, []);

  return null;
}
